export default {
    data() {
        return{
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/integrated/integrated.vue.js